
function firstTime() {
    return {
        type: 'FIRST_TIME',
        scroll: true
    };
}


export default firstTime;